import { render, staticRenderFns } from "./InstitutionalQnrResultsSectionView.vue?vue&type=template&id=b6f937de&scoped=true&"
import script from "./InstitutionalQnrResultsSectionView.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrResultsSectionView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalQnrResultsSectionView.vue?vue&type=style&index=0&id=b6f937de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f937de",
  null
  
)

export default component.exports